import { useMemo } from 'react';

import { useThrottledValue } from '@waypoint/react/hooks';

import { useDocumentStoreContext } from './context';
import getCustomColors from './helpers/getCustomColors';

export default function useDocumentColors(): string[] {
  const { configuration, layoutConfiguration } = useDocumentStoreContext();

  const internalConfiguration = useThrottledValue(configuration, 1000);
  const internalLayoutConfiguration = useThrottledValue(layoutConfiguration, 1000);
  return useMemo(() => {
    const c = getCustomColors(internalConfiguration);
    const l = getCustomColors(internalLayoutConfiguration);
    return [...new Set([...c, ...l])].sort();
  }, [internalConfiguration, internalLayoutConfiguration]);
}
